<template>
	<v-card
		v-bind="$attrs"
		class="d-flex flex-column"
	>
		<v-card-title
			class="d-flex align-center"
		>
			<v-icon
				icon="$cloudUpload"
				start
			/>
			<translate>{{ title }}</translate>
		</v-card-title>
		<v-card-text>
			<v-row
				v-for="input in dataInputs"
				:key="input.name"
			>
				<v-col>
					<file-input
						v-model="input.model"
						hide-details
						:label="$gettext('Upload ' + input.name + ' file')"
						:accept="accept"
					/>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions class="justify-self-end">
			<v-btn
				color="primary"
				block
				:disabled="uploading"
				@click="upload"
			>
				<translate>Upload</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	displayError,
	inform,
} from 'laravel-front-library';

export default {
	name: 'FileUpload',
	props: {
		inputs: {
			type: Array,
			required: true
		},
		uploadName: {
			type: String,
			required: true,
		},
		endPoint: {
			type: String,
			required: true
		},

		accept: {
			type: String,
			required: false,
			default: '',
		},
		title: {
			type: String,
			required: false,
			default: 'Upload File'
		},

	},
	data () {
		return {
			dataInputs: [],
			uploading: false
		};
	},

	created () {
		this.inputs.forEach((inputName) => this.dataInputs.push(
			{
				name: inputName, model: null
			}
		));
	},


	methods: {
		/**
		 * Upload files
		 *
		 * @returns {void}
		 */
		upload () {
			this.uploading = true;
			const formData = new FormData();

			if (this.dataInputs.length > 1) {
				this.dataInputs.forEach((dataInput) => formData.append(this.appendKeyName(dataInput.name), dataInput.model[0]));
			} else {
				this.dataInputs.forEach((dataInput) => formData.append(this.uploadName, dataInput.model[0]));
			}
			axios.post(this.endPoint, formData)
				.then(() => {
					inform(this.$gettext('File successfully uploaded'));
					window.location.reload();
				})
				.catch((error) => {
					if (error.response && error.response.status === 400 && error.response.data) {
						displayError(this.$gettext(error.response.data));
					} else {
						displayError('Exception while generating file, please contact administrator.');
						window.captureException(error);
					}
					this.uploading = false;
				});
		},

		/**
		 * Returns the key name from original name
		 *
		 * @param {string} name
		 * @returns {string} Key name
		 */
		appendKeyName (name) {
			return this.uploadName + '[' + name + ']';
		}
	}
};
</script>
